import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import "./UserRowPlaceholder.scss";

const UserRowPlaceholder = ({ className, displayType }) => (
	<div className={classnames(`${displayType}-placeholder`, className)}>
		<div className={`${displayType}-placeholder-thumb`} />

		<div className={`${displayType}-placeholder-info`}>
			<div className={`${displayType}-placeholder-info-username`} />
			<div className={`${displayType}-placeholder-info-meta`} />
		</div>

		<div className={`${displayType}-placeholder-match-info`}>
			<div className={`${displayType}-placeholder-match-info-percentage`} />
		</div>
	</div>
);

UserRowPlaceholder.displayTypes = {
	Row: "userrow",
	Card: "usercard",
	LargeCard: "userlargecard",
	SmallCard: "usersmallcard",
};

UserRowPlaceholder.propTypes = {
	className: PropTypes.string,
	displayType: PropTypes.oneOf(Object.values(UserRowPlaceholder.displayTypes)),
};
UserRowPlaceholder.defaultProps = {
	className: undefined,
	displayType: UserRowPlaceholder.displayTypes.Row,
};

export default UserRowPlaceholder;



// WEBPACK FOOTER //
// ./src/shared/components/UserRowPlaceholder.jsx